import { inject, Injectable } from '@angular/core';
import { MapUrlApiFrom } from '@api-gen/models/map-url-api-from';
import { ApiFromServiceV2VService } from '@api-gen/services/api-from-service-v-2-v.service';
import { ErrorResponse } from '@api/models';
import { StartWithUnit } from '@core/operators/start-with-unit';
import { RxState } from '@rx-angular/state';
import { RxActionFactory, RxActions } from '@rx-angular/state/actions';
import { Observable } from 'rxjs';


export interface IMapState {
    loading: Record<StartWithUnit, boolean>;
    errors: Record<StartWithUnit, ErrorResponse>;
    maps: MapUrlApiFrom[];
}

export interface IMapAction {
    requestMaps: MapUrlApiFrom[];
}

@Injectable()
export class MapState extends RxState<IMapState> {
    readonly #apiFromServiceV2VService: ApiFromServiceV2VService = inject(ApiFromServiceV2VService);

    public readonly loading$: Observable<Record<StartWithUnit, boolean>> = this.select('loading');
    public readonly errors$: Observable<Record<StartWithUnit, ErrorResponse>> = this.select('errors');

    public readonly maps$: Observable<MapUrlApiFrom[]> = this.select('maps');

    readonly #actions: RxActions<IMapAction> = new RxActionFactory<IMapAction>().create();

    constructor() {
        super();

        this.setDefaultState();
        this.connectSelectors();

        this.requestMaps();
    }

    public requestMaps(): void {
        this.hold(
            this.#apiFromServiceV2VService.apiV3ServiceMapUrlListGet(),
            this.#actions.requestMaps,
        );
    }

    private setDefaultState(): void {
        this.set({
            loading: null,
            errors: null,
            maps: [],
        });
    }

    private connectSelectors(): void {
        this.connect('maps', this.#actions.requestMaps$);
    }
}
